/*eslint-disable*/
import React from 'react'
import { useTranslation } from 'react-i18next'

// components
import CloseIcon from '@mui/icons-material/Close'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined'
import { IconButton, TextField, useTheme } from '@mui/material'
import SearchIcon from '../../assets/Search.svg'

// hooks
import usePreviousSearchText from '../../hooks/usePreviousSearchText'

const SearchBarComponent = ({
  searchText,
  setSearchText,
  getUsers,
  placeholderText,
  isModal = true,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { previousSearchText, setPreviousSearchText } =
    usePreviousSearchText(searchText)

  const handleSearch = (e) => {
    const { value } = e?.target
    setSearchText(value)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && searchText !== previousSearchText && isModal) {
      setPreviousSearchText(searchText)
      getUsers(searchText)
    }
  }

  const handleClick = () => {
    setPreviousSearchText(searchText)
    getUsers(searchText)
  }

  return (
    <div>
      <TextField
        placeholder={t(placeholderText)}
        value={searchText}
        size="small"
        onChange={handleSearch}
        onKeyDown={handleKeyDown}
        InputProps={{
          startAdornment: (
            <div style={{ marginRight: '16px' }}>
              <img src={SearchIcon} alt="" />
            </div>
          ),
          endAdornment: searchText?.length > 0 && (
            <div style={{ display: 'flex', gap: '16px' }}>
              <IconButton
                onClick={() => setSearchText('')}
                sx={{ color: '#312C2A' }}
              >
                <CloseIcon />
              </IconButton>
              {isModal && (
                <IconButton
                  onClick={() => handleClick()}
                  sx={{ backgroundColor: '#312C2A' }}
                  disableFocusRipple
                >
                  <ArrowForwardOutlinedIcon sx={{ color: '#FFFFFF' }} />
                </IconButton>
              )}
            </div>
          ),
        }}
        sx={{
          width: {
            xs: '100%',
            sm: isModal ? '100%' : '300px',
            md: isModal ? '875px' : '483px',
          },
          '&::placeholder': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'block',
          },
          padding: '10px 10px 10px 2px',
          borderBottom: '1px solid #C1BBB3',
          marginTop: isModal ? '20px' : '0',
          gap: '10px',
          backgroundColor: isModal ? '#8C755D0D' : '#FFFFFF',
          '& .MuiInputBase-input::placeholder': {
            color: '#564C47',
            opacity: 1,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none', // Remove the border
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none', // Remove the border on hover
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none', // Remove the border when focused
          },
        }}
      />
    </div>
  )
}

export default SearchBarComponent
